(function () {
    'use strict';

    function excludeByArrayProperty() {
        return function (items, arrayProperty, excludeArrayItems, excludeArrayProperty) {
            return items.filter(function (item) {
                return excludeArrayItems.map(function (excludeItem) {
                    return excludeItem[excludeArrayProperty];
                }).indexOf(item[arrayProperty]) === -1;
            });
        };
    }

    angular.module('ecap.common').filter('excludeByArrayProperty', excludeByArrayProperty);
})();